const delimiterCellRegex = /^:?[-=]+:?$/;
function splitTableRowCells(line) {
  const cells = [];
  let current = "";
  for (let index = 0; index < line.length; index++) {
    const char = line[index];
    if (char === "\\" && line[index + 1] === "|") {
      current += "\\|";
      index++;
    } else if (char === "|") {
      cells.push(current.trim());
      current = "";
    } else {
      current += char;
    }
  }
  cells.push(current.trim());
  if (cells.length > 0 && cells[0] === "") {
    cells.shift();
  }
  if (cells.length > 0 && cells[cells.length - 1] === "") {
    cells.pop();
  }
  return cells;
}
function isTableRowLine(line) {
  const trimmed = line.trim();
  if (!trimmed.includes("|")) {
    return false;
  }
  const unescapedPipeCount = (trimmed.match(/(?<!\\)\|/g) ?? []).length;
  return trimmed.startsWith("|") || trimmed.endsWith("|") || unescapedPipeCount >= 2;
}
function isDelimiterRowLine(line) {
  const cells = splitTableRowCells(line.trim());
  return cells.length > 0 && cells.every((cell) => delimiterCellRegex.test(cell));
}
function buildDelimiterRow(columnCount, existingCells = []) {
  const cells = Array.from({ length: columnCount }, (_, index) => {
    const existing = existingCells[index];
    if (existing && delimiterCellRegex.test(existing)) {
      const left = existing.startsWith(":");
      const right = existing.endsWith(":");
      if (left && right) {
        return ":---:";
      }
      if (left) {
        return ":---";
      }
      if (right) {
        return "---:";
      }
    }
    return "---";
  });
  return `| ${cells.join(" | ")} |`;
}
function repairMarkdownTables(text) {
  const lines = text.split("\n");
  const output = [];
  let index = 0;
  let insideCodeFence = false;
  while (index < lines.length) {
    const line = lines[index];
    if (line === void 0) {
      break;
    }
    if (/^\s*(```|~~~)/.test(line)) {
      insideCodeFence = !insideCodeFence;
      output.push(line);
      index++;
      continue;
    }
    if (insideCodeFence || !isTableRowLine(line)) {
      output.push(line);
      index++;
      continue;
    }
    const blockLines = [];
    let cursor = index;
    while (cursor < lines.length) {
      const candidate = lines[cursor];
      if (candidate === void 0) {
        break;
      }
      if (isTableRowLine(candidate)) {
        blockLines.push(candidate);
        cursor++;
        continue;
      }
      const nextLine = lines[cursor + 1];
      if (candidate.trim() === "" && nextLine !== void 0 && isTableRowLine(nextLine)) {
        cursor++;
        continue;
      }
      break;
    }
    if (blockLines.length < 2) {
      output.push(line);
      index++;
      continue;
    }
    const headerLine = blockLines[0];
    if (headerLine === void 0) {
      output.push(line);
      index++;
      continue;
    }
    const headerCellCount = splitTableRowCells(headerLine.trim()).length;
    const repairedBlock = [...blockLines];
    const delimiterLine = repairedBlock[1];
    if (delimiterLine !== void 0 && isDelimiterRowLine(delimiterLine)) {
      const delimiterCells = splitTableRowCells(delimiterLine.trim());
      const isValid = delimiterCells.length === headerCellCount && delimiterCells.every((cell) => /^:?-+:?$/.test(cell));
      if (!isValid) {
        repairedBlock[1] = buildDelimiterRow(headerCellCount, delimiterCells);
      }
    } else if (!repairedBlock.some(isDelimiterRowLine) && headerCellCount >= 2 && repairedBlock.every(
      (rowLine) => splitTableRowCells(rowLine.trim()).length === headerCellCount
    )) {
      repairedBlock.splice(1, 0, buildDelimiterRow(headerCellCount));
    } else if (!repairedBlock.some(isDelimiterRowLine)) {
      output.push(...lines.slice(index, cursor));
      index = cursor;
      continue;
    }
    const lastOutputLine = output[output.length - 1];
    if (lastOutputLine !== void 0 && lastOutputLine.trim() !== "") {
      output.push("");
    }
    output.push(...repairedBlock);
    const trailingLine = lines[cursor];
    if (trailingLine !== void 0 && trailingLine.trim() !== "") {
      output.push("");
    }
    index = cursor;
  }
  return output.join("\n");
}
export {
  repairMarkdownTables
};
//# sourceMappingURL=markdownTableRepair.js.map
